import { breakpoints, theme } from '@notino/react-styleguide';

import { css } from '@linaria/core';
import { styled } from '@linaria/react';

export const variantsInSelectBoxOpening = css`
  @keyframes variantsInSelectBoxOpening {
    from {
      transform: translateY(100%);
      overflow: hidden;
    }
    to {
      transform: translateY(0);
      overflow: auto;
    }
  }
  animation-name: variantsInSelectBoxOpening;
  display: flex;
`;

export const variantsInSelectBoxClosing = css`
  @keyframes variantsInSelectBoxClosing {
    from {
      transform: translateY(0);
    }
    to {
      transform: translateY(100%);
    }
  }
  animation-name: variantsInSelectBoxClosing;
  display: none;
`;

export const OpenedVariants = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  flex-wrap: wrap;
  align-content: flex-start;
  background-color: ${theme.color.background.primary};
  z-index: 10002; /* daktela is 10001 */
  overflow: auto;
  animation-duration: 0.6s;
  -webkit-overflow-scrolling: touch;

  @media (min-width: ${breakpoints.lg}) {
    position: absolute;
    top: auto;
    left: auto;
    height: auto;
    max-height: 21.875rem;
    border: 1px solid ${theme.color.border.divider};
    border-top: 0;
    animation: none;
  }
`;
